export default {"src":"/_next/static/media/WhiplashInjuries.cfd3b6db.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};